import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'environments/environment';

import { ActivatedRoute, Router } from '@angular/router';
import { map } from "rxjs/operators";
import { Observable, BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-iframecontainer',
  templateUrl: './iframecontainer.component.html',
  styleUrls: ['./iframecontainer.component.css', '../../styles/main2.css']
})
export class IframecontainerComponent implements OnInit {
  notifyListUrl: SafeResourceUrl;
  url: string;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.activatedRoute.paramMap
      .pipe(map(() => window.history.state)).subscribe(x => {
        this.url = x['url'];
      });

    // WORKING but not hiding url
    /*
    this.activatedRoute.params.subscribe(params => {
      this.url = params['url'];
    });
    console.log('this.url: ' + this.url);
    */

    this.notifyListUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
}
